<template>
	<div style="max-width: 100%;">
		<q-table :data="tableData"
				 :columns="columns"
         :visible-columns="visibleColumns"
				 :pagination.sync="pagination"
				 :rows-per-page-options="rowsPerPageOptions"
				 :pagination-label="getPaginationLabel"
				 :loading="loadingLogs"
				 row-key="intPalletId"
				 @request="onRequest"
				 class="sticky-header-table first-column-sticky"
				 ref="logTable"
		>
			<template v-slot:loading>
				<q-inner-loading showing color="primary"/>
			</template>
			<template v-slot:body="props">
				<pallet-table-row :props="props" @showPalletLogList="showPalletLogList"/>
			</template>
		</q-table>

		<pallet-dialog :visible="showPalletDialog" @hide="showPalletDialog = false" :name="name" :pallet="pallet"/>
	</div>
</template>

<script>
	import PalletTableRow from "@/components/common/pallet/PalletTableRow";
	import {logSearchPageSize} from "@/common/config";
	import LogSearchMixin from "@/mixins/LogSearchMixin";
	import PalletDialog from "@/components/common/pallet/PalletDialog";
	import LogPropertiesResolver from "@/mixins/LogPropertiesResolver";
	import {mapGetters} from "vuex";
  import TableMethods from "@/mixins/TableMethods";

	export default {
		name: "PalletTable",
		components: {PalletDialog, PalletTableRow},
		mixins: [LogSearchMixin, LogPropertiesResolver, TableMethods],
		data() {
			return {
				showPalletDialog: false,
				pallet: null,
        visibleColumns: [
          'place', 'name', 'species', 'palletArea', 'palletResultAreaNotRemeasured',
          'inPalletPercentage', 'maxLength', 'bundleCount',
          'palletInfo', 'palletInfoInternal', 'actions',
        ],
				columns: [
					{name: 'place', label: this.$t('place'), align: 'left'},
					{name: 'name', label: this.$t('pallet'), field: 'strPalletNo', align: 'left', required: true},
					{name: 'species', label: this.$t('species'), align: 'left', required: true},
					{
						name: 'palletArea',
						label: `${this.$t('palletArea')} (${this.$t('unit.sqm')})`,
						align: 'right',
						required: true
					},
          {name: 'palletResultAreaNotRemeasured', label: `${this.$t('packageArea')} (${this.$t('unit.sqm')})`, align: 'right'},
          {name: 'inPalletPercentage', label: `${this.$t('inPalletPercentage')} (${this.$t('unit.percentage')})`, align: 'right'},
					{
						name: 'palletResultArea',
						label: `${this.$t('measuredArea')} (${this.$t('unit.sqm')})`,
						align: 'right',
					},
					{
						name: 'percentageArea',
						label: `${this.$t('measuredArea')} (${this.$t('unit.percentage')})`,
						align: 'right'
					},
					{
						name: 'maxLength',
						label: `${this.$t('maxLength')} (${this.$t('unit.cm')})`,
						align: 'right',
						required: true
					},
					{name: 'bundleCount', label: this.$t('bundleCount'), align: 'left'},
					{name: 'palletInfo', label: this.$t('palletInfo'), align: 'left'},
					{name: 'palletInfoInternal', label: this.$t('palletInfoInternal'), align: 'left'},
					{name: 'actions', label: '', align: 'right'}
				],
				pagination: {
					page: 1,
					rowsPerPage: logSearchPageSize,
					rowsNumber: 0
				},
				rowsPerPageOptions: [logSearchPageSize]
			}
		},
    mounted() {
      this.toggleOptionalColumns();
    },
    watch: {
			logSearchResults(newResults, oldResults) {
				if (oldResults.length < newResults.length) {
					this.pagination.page = 1;
				}

				this.pagination.rowsNumber = newResults.length + 1;

        this.toggleOptionalColumns();
			}
		},
		computed: {
			...mapGetters(['loadingLogs']),
			tableData() {
				return this.logSearchResults.slice(
					(this.pagination.page - 1) * logSearchPageSize,
					this.pagination.page * logSearchPageSize
				);
			},
			name() {
				if(this.pallet) {
					return this.pallet.name || `${this.$t('pallet')} ${this.palletNo}`;
				}
				return '';
			}
		},
		methods: {
			async onRequest(props) {
				let {page, rowsPerPage, rowsNumber, sortBy, descending} = props.pagination;

				if (page * rowsPerPage > this.logSearchResults.length) {
					await this.loadAdditionalResults();
					// scroll back to top
					this.$refs.logTable.scrollTo(0);
				}

				this.pagination.page = page;
			},
			getPaginationLabel(firstRowIndex, endRowIndex, totalRowsNumber) {
				return '';
			},
			showPalletLogList(pallet) {
				this.pallet = pallet;
				this.showPalletDialog = true;
			},
      toggleOptionalColumns() {
        this.toggleColumns(['palletResultArea', 'percentageArea'], (this.logSearchParams.lengthMax));
      }
    }
	}
</script>